import {Card} from "./Card";

var template = require('./national_recruitment_card.twig');

export class NationalRecruitmentCard extends Card
{
    constructor() {
        super();
        this.dom = $(twig({data: template}).render());
        this.national_recruitment_dd = this.dom.find('#national_recruitment_dd');

        this.national_recruitment_dd.on('change', () => {
            this.cardFilledOutTriggers();
        });
    }

    setRequiredFields(fields) {
        super.setRequiredFields(fields);
        if (typeof this.requiredFields.mf_meeting === 'undefined') {
            this.requiredFields.mf_meeting = {};
        }
        this.requiredFields.mf_meeting.national_recruitment = 1;
    }

    getValue() {
        if (!this.dom.is(':visible')) {
            return '';
        }

        return this.national_recruitment_dd.val();
    }
}
